import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { TooltipProvider } from './components/ui/tooltip';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found in index.html');

createRoot(container).render(
  <StrictMode>
    {/*
      Outermost boundary. AppShell has its own around the routed page, which
      is the one that normally fires and keeps the nav usable; this one exists
      for what that cannot reach — the shell, login, verify, the router and
      the providers. Without it those render to a blank page with no way back.
    */}
    <ErrorBoundary>
      {/* One provider for the whole app. Radix needs an ancestor provider for
          any tooltip to open, and mounting one per screen is how half of them
          quietly stop working. */}
      <TooltipProvider>
        <App />
      </TooltipProvider>
    </ErrorBoundary>
  </StrictMode>,
);
